export const IMG_WAVVW_COM = 'img.wavve.com'
export const IMAGE_WAVVE_COM = 'image.wavve.com'
export const IMAGE_CDN_WAVVE_COM = 'image.cdn.wavve.com'
export const IMG_POOQ_CO_KR = 'img.pooq.co.kr'

export const DEV_IMG_WAVVW_COM = 'dev-img.wavve.com'
export const DEV_IMAGE_WAVVE_COM = 'dev-image.wavve.com'
export const DEV_IMG_CDN_WAVVE_COM = 'dev-image.cdn.wavve.com'
export const DEV_IMG_POOQ_CO_KR = 'dev-img.pooq.co.kr'

export const QA_IMG_WAVVW_COM = 'qa-img.wavve.com'
export const QA_IMAGE_WAVVE_COM = 'qa-image.wavve.com'
export const QA_IMG_CDN_WAVVE_COM = 'qa-image.cdn.wavve.com'
export const QA_IMG_POOQ_CO_KR = 'qa-img.pooq.co.kr'
